import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/shadcn/collapsible"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuGroup,
  DropdownMenuItem
} from "@/components/shadcn/dropdown-menu"

import {
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
  useSidebar,
} from "@/components/shadcn/sidebar"

import { Icon } from '@iconify-icon/solid';
import { Show } from "solid-js";

export function SidebarItem(props) {

  const { state } = useSidebar();

  const hasItems = () => props.item.items && props.item.items.length > 0;

  const isLabel = () => props.item.isLabel ?? false;

  if (isLabel()) {
    return (
      <Show when={state() !== 'collapsed'}>
        <SidebarMenuItem key={props.item.title}>
          <SidebarMenuButton class="flex items-center h-8 shrink-0 items-center rounded-md px-2 text-xs font-medium" tooltip={props.item.title}>
            <span>{props.item.title}</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </Show>
    );
  }

  if (!hasItems()) {
    return (
      <SidebarMenuItem key={props.item.title}>
        <SidebarMenuButton class="flex items-center ps-1.5" tooltip={props.item.title} as={innerProps => <a href={props.item.url} {...innerProps} />} >
          {props.item.icon && <Icon icon={props.item.icon} class="w-5 h-5 flex justify-center" />}
          <Show when={state() !== 'collapsed'}>
            <span>{props.item.title}</span>
          </Show>
        </SidebarMenuButton>
      </SidebarMenuItem>
    );
  }

  return (
    <Switch>
      <Match when={state() === 'collapsed'}>
        <SidebarMenuItem key={props.item.title}>
          <DropdownMenu
            placement="right-start"
          >
            <DropdownMenuTrigger as={innerProps => <SidebarMenuButton
              class="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
              tooltip={props.item.title}
              {...innerProps}
            />}>
              {props.item.icon && <Icon icon={props.item.icon} class="w-5 h-5 justify-center" />}
            </DropdownMenuTrigger>
            <DropdownMenuContent
              class="w-[--radix-dropdown-menu-trigger-width] min-w-32 rounded-md"
              sideOffset={4}
            >
              <DropdownMenuGroup>
                <For each={props.item.items ?? []}>{(subItem) => (
                  <DropdownMenuItem key={subItem.title} as={innerProps => <a href={subItem.url} {...innerProps} />}>
                    <span>{subItem.title}</span>
                  </DropdownMenuItem>
                )}</For>
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>
        </SidebarMenuItem>
      </Match>
      <Match when={state() !== 'collapsed'}>
        <Collapsible
          key={props.item.title}
          defaultOpen={props.item.isActive}
          class="group/collapsible"
          as={innerProps => <SidebarMenuItem {...innerProps} />}
        >
          <CollapsibleTrigger as={innerProps => <SidebarMenuButton class="flex items-center" tooltip={props.item.title} {...innerProps} />}>
            {props.item.icon && <Icon icon={props.item.icon} class="w-5 h-5 justify-center" />}
            <Show when={state() !== 'collapsed'}>
              <span>{props.item.title}</span>
            </Show>
            <Icon icon="lucide:chevron-right" class="ml-auto transition-transform duration-200 group-data-[expanded]/collapsible:rotate-90" />
          </CollapsibleTrigger>
          <CollapsibleContent>
            <SidebarMenuSub>
              <For each={props.item.items ?? []}>{(subItem) => (
                <SidebarMenuSubItem key={subItem.title}>
                  <SidebarMenuSubButton as={innerProps => <a href={subItem.url} {...innerProps} />}>
                    <span>{subItem.title}</span>
                  </SidebarMenuSubButton>
                </SidebarMenuSubItem>
              )}</For>
            </SidebarMenuSub>
          </CollapsibleContent>
        </Collapsible>
      </Match>
    </Switch>
  );
}
